import clsx from 'clsx';
import { type ReactNode } from 'react';

import { darkGreen } from '@/theme/colors';

import MaterialIcon from '../Icon/MaterialIcon';
import Link from '../Link';
import s from './ProjectBar.module.scss';

interface ProjectBarFallbackProps {
  to: string;
  children: ReactNode;
  className?: string;
}

/**
 * Stands in for ProjectBar when the project is missing (ENG-5787). The bar is the page's only
 * way back, and its bottom rule and spacing are what separate it from the page header, so
 * dropping it outright strands the user and collapses the layout. Same shell and styles as
 * ProjectBar, with a plain back link to wherever the caller says is up.
 */
function ProjectBarFallback({ to, children, className }: ProjectBarFallbackProps): JSX.Element {
  return (
    <div className={clsx(s.bar, className)}>
      <div className={s.title}>
        <Link className={s.link} to={to}>
          <MaterialIcon color={darkGreen} className={s.icon} icon="arrow_back" />
          {children}
        </Link>
      </div>
    </div>
  );
}

export default ProjectBarFallback;
